export const createIncrementalCode = (number:number)=>{
    const numberStr = number.toString();
    const loops = 9-numberStr.length
    let finalCode = numberStr;
    for (let index = 0; index < loops; index++) {
        finalCode = "0"+finalCode
    }
    return finalCode;
}